import { render } from "./ImprimirNecessidade.vue?vue&type=template&id=5f0cb0fe&scoped=true"
import script from "./ImprimirNecessidade.vue?vue&type=script&lang=js"
export * from "./ImprimirNecessidade.vue?vue&type=script&lang=js"

import "./ImprimirNecessidade.vue?vue&type=style&index=0&id=5f0cb0fe&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0cb0fe"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTable,QTd,QBtn});
